import withSharedStyles from "../theme/Shared.style";

// Saved-address picker (header dropdown / checkout dialog)
const withCustomStyles = withSharedStyles(theme => {
  const { color, fontSize } = theme.tokens;
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: 14,
      padding: 16,
      backgroundColor: color.bg,
      boxSizing: "border-box"
    },
    modal: {
      padding: 0
    },
    head: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12
    },
    title: {
      margin: 0,
      fontSize: fontSize.title,
      fontWeight: 800,
      color: color.ink
    },
    closeButton: {
      marginRight: -8
    },
    list: {
      display: "flex",
      flexDirection: "column",
      gap: 8
    }
  };
});

export default withCustomStyles;
